import GATSBY_COMPILED_MDX from "/home/runner/work/aiid/aiid/site/gatsby-site/content/terms-of-use/index.mdx";
import React, {useEffect} from 'react';
import HeadContent from 'components/HeadContent';
import {graphql, Link} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import Components from 'components/ui/MdxComponents';
import TranslationBadge from 'components/i18n/TranslationBadge';
import {Trans} from 'react-i18next';
import Outline from 'components/Outline';
import {useLayoutContext} from 'contexts/LayoutContext';
function Doc(props) {
  let {data: {mdx, enMdx}, children} = props;
  if (!mdx) {
    mdx = enMdx;
  }
  const rightSidebar = React.createElement(React.Fragment, null, React.createElement(Outline, {
    location: props.location
  }));
  const {displayRightSidebar} = useLayoutContext();
  useEffect(() => {
    displayRightSidebar(rightSidebar);
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'titleWrapper'
  }, React.createElement("h1", null, mdx.fields.title), mdx.frontmatter.aiTranslated && React.createElement("div", null, React.createElement(TranslationBadge, {
    className: "d-inline-block"
  }), React.createElement(Link, {
    className: "d-inline-block ml-2",
    to: mdx.frontmatter.slug
  }, React.createElement(Trans, null, "View Original")))), React.createElement("div", {
    className: "styled-main-wrapper prose",
    "data-testid": "doc-content"
  }, React.createElement(MDXProvider, {
    components: Components
  }, children)));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Doc, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = props => {
  const {location: {pathname}, data: {mdx}} = props;
  const metaTitle = mdx.frontmatter.metaTitle;
  const metaDescription = mdx.frontmatter.metaDescription;
  return React.createElement(HeadContent, Object.assign({
    path: pathname
  }, {
    metaTitle,
    metaDescription
  }));
};
export const pageQuery = graphql`
  query DocsTemplateQuery($slug: String!, $locale: String!) {
    site {
      siteMetadata {
        title
        docsLocation
      }
    }
    mdx(fields: { locale: { eq: $locale } }, frontmatter: { slug: { eq: $slug } }) {
      fields {
        id
        title
        slug
      }
      tableOfContents
      parent {
        ... on File {
          relativePath
        }
      }
      frontmatter {
        metaTitle
        metaDescription
        aiTranslated
        slug
      }
    }
    enMdx: mdx(fields: { locale: { eq: "en" } }, frontmatter: { slug: { eq: $slug } }) {
      fields {
        id
        title
        slug
      }
      tableOfContents
      parent {
        ... on File {
          relativePath
        }
      }
      frontmatter {
        metaTitle
        metaDescription
        aiTranslated
        slug
      }
    }
  }
`;
